import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const userInvitationApi = createApi({
  reducerPath: 'userInvitationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/users/invitation',
    credentials: 'include'
  }),
  endpoints: (builder) => ({
    acceptInvitationUser: builder.mutation({
      query: (body) => ({
        method: 'PATCH',
        body: { user: body }
      }),
      invalidatesTags: ['UserInvitation']
    })
  })
})

export const { useAcceptInvitationUserMutation } = userInvitationApi
export { userInvitationApi }
